import React from 'react';
import Test from './Test';

const Lose = () => {
    return (
        <div>
            <Test/>
            <h1>You Lost</h1>
        </div>
    );
};

export default Lose;